import { FormattedMessage } from 'react-intl';

import { screenReaderOnly } from '../../../styles/screen-reader-only.sty.js';
import { useSelectMenuContext } from '../hooks/use-select-menu-context.js';

interface SelectLiveRegionProps {
  loading?: boolean;
}

/**
 * Single persistent live region for all Select announcements. Kept outside
 * the portal-rendered Menu so it is already in the DOM before the menu opens
 * — content changes are mutations on an existing node, which is the only
 * pattern reliably announced by screen readers.
 * @internal
 */
export function SelectLiveRegion({ loading }: Readonly<SelectLiveRegionProps>) {
  const { state: menuOpen, announcementText } = useSelectMenuContext();

  return (
    <output className={screenReaderOnly}>
      {menuOpen && loading ? (
        <FormattedMessage
          defaultMessage="Loading"
          id="cycz+bYG+VH7Of4e"
          description="Label for the loading state."
        />
      ) : (
        announcementText || null
      )}
    </output>
  );
}
